// extracted by mini-css-extract-plugin
export default {"brand-cobalt":"rgb(64, 36, 211)","lightest-text-color":"rgb(193, 198, 205)","link":"styles_link__BJFsL","disabled":"styles_disabled__F3o6a","icon":"styles_icon__Uv0JA"};